import { appSettingsCustomEventsData } from "@dashboardApi/apis/appSettingsCustomEventsData/constants";
import { appSettingsCustomEventsTags } from "@dashboardApi/apis/appSettingsCustomEventsTags/constants";
import { appSettingsSegmentablePropertyUsage } from "@dashboardApi/apis/appSettingsSegmentablePropertyUsage/constants";

import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdCustomEventsSettingsCacheKeys: AllRouteEndpoints[] = [
  appSettingsCustomEventsData,
  appSettingsSegmentablePropertyUsage,
  appSettingsCustomEventsTags,
];
